var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNorthEast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5111 13.331L8.59691 43.2453C8.09377 43.7484 7.4534 44 6.67581 44C5.89823 44 5.25786 43.7484 4.75472 43.2453C4.25157 42.7421 4 42.1018 4 41.3242C4 40.5466 4.25157 39.9062 4.75472 39.4031L34.669 9.48885H19.3002C18.5226 9.48885 17.8708 9.22584 17.3448 8.69983C16.8188 8.17381 16.5557 7.52201 16.5557 6.74443C16.5557 5.96684 16.8188 5.31504 17.3448 4.78902C17.8708 4.26301 18.5226 4 19.3002 4H41.2556C42.0332 4 42.685 4.26301 43.211 4.78902C43.737 5.31504 44 5.96684 44 6.74443V28.6998C44 29.4774 43.737 30.1292 43.211 30.6552C42.685 31.1812 42.0332 31.4443 41.2556 31.4443C40.478 31.4443 39.8262 31.1812 39.3002 30.6552C38.7742 30.1292 38.5111 29.4774 38.5111 28.6998V13.331Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNorthEast);
export default __webpack_public_path__ + "static/media/icon-north_east.9a35e205.svg";
export { ForwardRef as ReactComponent };